import { useQuery } from "@tanstack/react-query";
import { getNotificationTemplateById } from "../../api/apiNotificationTemplates";

export const useGetNotificationTemplateById = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["notification-template", id],
        queryFn: () => getNotificationTemplateById(id),
        enabled: !!id,
        retry: false,
    });

    return {
        template: data?.data || null,
        isLoading,
        error,
        refetch,
    };
};
